import { Music, Globe, Database } from "lucide-react";
import { FooterLink } from "./FooterLinks";

export const discoverLinks: FooterLink[] = [
  { label: "Buscar Gimnasios", to: "/directory" },
  { label: "Entrenadores Personales", to: "/trainers" },
  { label: "Eventos Deportivos", to: "/events" },
  { label: "Videos de Entrenamiento", to: "/videos" },
  { label: "Artículos y Blog", to: "/articles" },
  { label: "Cerca de Mí", to: "/cerca-de-mi" },
];


export const professionalsLinks: FooterLink[] = [
  { label: "Entrenador Personal - 90 Días Gratis", to: "/become-trainer", emoji: "🏋️" },
  { label: "Hazte Fisioterapeuta", to: "/become-physiotherapist", emoji: "💆" },
  { label: "Hazte Nutricionista", to: "/become-nutritionist", emoji: "🥗" },
  { label: "Tiendas y Proveedores", to: "/tiendas-proveedores", emoji: "🏪" },
  { label: "Registra tu Negocio", to: "/submit-listing" },
];

export const landingPagesLinks: FooterLink[] = [
  { label: "Entrenadores Personales", to: "/become-trainer", emoji: "🏋️" },
  { label: "Fisioterapeutas", to: "/become-physiotherapist", emoji: "💆" },
  { label: "Nutricionistas", to: "/become-nutritionist", emoji: "🥗" },
  { label: "Estudios de Yoga", to: "/landing-yoga", emoji: "🧘" },
  { label: "Boxes de CrossFit", to: "/landing-crossfit", emoji: "💪" },
  { label: "Gimnasios", to: "/landing-fitness", emoji: "🏢" },
  { label: "Centros de Pilates", to: "/landing-pilates", emoji: "🤸" },
  { label: "Academias de Baile", to: "/landing-dance", emoji: "💃" },
  { label: "Artes Marciales", to: "/landing-martial-arts", emoji: "🥋" },
];

export const internationalLinks: FooterLink[] = [
  { label: "🇬🇧 Ekselencia English", to: "https://en.ekselencia.com", icon: Globe, external: true },
  { label: "🇳🇱 Ekselencia Nederland", to: "https://nl.ekselencia.com", icon: Globe, external: true },
];

export const legalLinks: FooterLink[] = [
  { label: "Preguntas Frecuentes", to: "/faq" },
  { label: "Términos y Condiciones", to: "/terminos" },
  { label: "Política de Privacidad", to: "/privacidad" },
  { label: "Política de Devoluciones", to: "/devoluciones" },
  { label: "Métodos de Pago", to: "/metodos-pago" },
  { label: "Mapa del Sitio", to: "/sitemap" },
  { label: "Dataset LLM", to: "/llm-dataset.txt", icon: Database },
];
